import { render, staticRenderFns } from "./userSsegmentationRetention.vue?vue&type=template&id=d75a9f9e&scoped=true&"
import script from "./userSsegmentationRetention.vue?vue&type=script&lang=js&"
export * from "./userSsegmentationRetention.vue?vue&type=script&lang=js&"
import style0 from "./userSsegmentationRetention.vue?vue&type=style&index=0&id=d75a9f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75a9f9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d75a9f9e')) {
      api.createRecord('d75a9f9e', component.options)
    } else {
      api.reload('d75a9f9e', component.options)
    }
    module.hot.accept("./userSsegmentationRetention.vue?vue&type=template&id=d75a9f9e&scoped=true&", function () {
      api.rerender('d75a9f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/userSsegmentationRetention.vue"
export default component.exports